import {Component} from "@angular/core";
import {RouteConfig, RouteDefinition} from "@angular/router-deprecated";
import {BlankComponent} from "../shared/blank/component";
import {SimpleComponent} from "./simple/component";
import {BindingComponent} from "./binding/component";
import {InputComponent} from "./input/component";
import {OutputComponent} from "./output/component";
import {HostListenerComponent} from "./hostlistener/component";
import {HostBindingComponent} from "./hostbinding/component";
import {PipeComponent} from "./pipe/component";
import {AttributeComponent} from "./attribute/component";
import {InjectableComponent} from "./injectable/component";
import {InjectComponent} from "./inject/component";
import {InjectorComponent} from "./injector/component";
import {ViewChildComponent} from "./viewchild/component";
import {ViewChildrenComponent} from "./viewchildren/component";
import {ContentChildComponent} from "./contentchild/component";
import {ContentChildrenComponent} from "./contentchildren/component";
import {ElementRefComponent} from "./elementref/component";
import {ApplicationRefComponent} from "./applicationref/component";
import {NgZoneComponent} from "./ngzone/component";
import {ChangeDetectorRefComponent} from "./changedetectorref/component";
import {ViewContainerRefComponent} from "./viewcontainerref/component";
import {ComponentResolverComponent} from "./componentresolver/component";

const ROUTES: Array<{ name: string; component: any }> = [
  { component: SimpleComponent, name: "Simple" },
  { component: BindingComponent, name: "Binding" },
  { component: InputComponent, name: "Input" },
  { component: OutputComponent, name: "Output" },
  { component: HostListenerComponent, name: "HostListener" },
  { component: HostBindingComponent, name: "HostBinding" },
  { component: PipeComponent, name: "Pipe" },
  { component: AttributeComponent, name: "Attribute" },
  { component: InjectableComponent, name: "Injectable" },
  { component: InjectComponent, name: "Inject" },
  { component: InjectorComponent, name: "Injector" },
  { component: ViewChildComponent, name: "ViewChild" },
  { component: ViewChildrenComponent, name: "ViewChildren" },
  { component: ContentChildComponent, name: "ContentChild" },
  { component: ContentChildrenComponent, name: "ContentChildren" },
  { component: ElementRefComponent, name: "ElementRef" },
  { component: ApplicationRefComponent, name: "ApplicationRef" },
  { component: NgZoneComponent, name: "NgZone" },
  { component: ChangeDetectorRefComponent, name: "ChangeDetectorRef" },
  { component: ViewContainerRefComponent, name: "ViewContainerRef" },
  { component: ComponentResolverComponent, name: "ComponentResolver" },
];

@Component({
  selector: "core-root",
  template: `
<module-root name="Core" [routes]="routes"></module-root>
  `,
})
@RouteConfig(
  ROUTES.map<RouteDefinition>((route) => {
    return {
      path: `/${route.name.toLowerCase()}`, component: route.component, name: route.name
    };
  }).concat({ path: "/", component: BlankComponent, useAsDefault: true })
)
export class CoreRoot {
  private routes = ROUTES;
}



/** WEBPACK FOOTER **
 ** ./script/core/root.component.ts
 **/